/**
 * @overview 游戏相关全局数据
 *
 * @author huojinzhao
 */

import { $http } from "@/utils";

export default {
  namespaced: true,

  state: {
    isShowHead: true, // 是否展示顶部面包屑
    subjects: [],

    structure: [],

    themes: [],
  },

  actions: {
    // 初始化编辑主题列表
    initThemes({ commit }) {
      return $http.get("/theme?page=1&per_page=100")
        .then(({ data }) => commit("initThemes", data));
    },

    // 初始化学科列表
    initSubjects({ commit }) {
      return $http.get("/course/index_before")
        .then(({ subjects }) => {
          let data = [];
          if (Array.isArray(subjects)) {
            data = subjects
              .filter(({ structure }) => structure && structure.length);

            commit("initSubjects", data);
          }
          return data;
        });
    },

    // 初始化学科结构列表
    initStructure({ state, commit }, id) {
      const subjectID = Number(id);

      const initCascader = (node, list = []) => {
        const arr = [...list, node.id];

        return node.leaf ? initCascader(node.leaf[0], arr) : arr;
      };

      const { structure } = state.subjects
        .find(subject => subjectID === subject.id);

      commit("initStructure", structure);

      return initCascader(structure[0]).toString();
    },
  },

  mutations: {
    initSubjects(state, subjects) {
      state.subjects = subjects;
    },

    initStructure(state, structure) {
      state.structure = structure;
    },

    initThemes(state, themes) {
      state.themes = themes;
    },
  },
};
